import { useState } from 'react';
import { Modal } from './Modal';

/**
 * Confirmación con motivo dentro de la app. Evita los prompt/confirm nativos
 * del navegador para anulaciones y operaciones sensibles.
 */
export function MotivoModal({
  title,
  description,
  confirmLabel = 'Anular',
  onClose,
  onConfirm,
  footnote = 'La operación genera el asiento de reverso y queda registrada en auditoría.',
}: {
  title: string;
  description?: string;
  confirmLabel?: string;
  onClose: () => void;
  onConfirm: (motivo: string) => Promise<void>;
  footnote?: string;
}) {
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (motivo.trim().length < 5) {
      setError('El motivo debe tener al menos 5 caracteres.');
      return;
    }
    setError(null);
    setSaving(true);
    try {
      await onConfirm(motivo.trim());
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'No se pudo completar la operación.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={title}
      eyebrow="Confirmación"
      onClose={saving ? () => undefined : onClose}
      footer={
        <>
          <button type="button" className="btn btn--outline" onClick={onClose} disabled={saving}>
            Cancelar
          </button>
          <button type="button" className="btn btn--danger" onClick={() => void submit()} disabled={saving}>
            {saving ? 'Procesando…' : confirmLabel}
          </button>
        </>
      }
    >
      <div className="modal-card__body">
        {description ? <p className="inline-note">{description}</p> : null}
        <label className="field">
          <span className="field-label">Motivo *</span>
          <textarea
            className="textarea"
            rows={3}
            value={motivo}
            onChange={(event) => setMotivo(event.target.value)}
            placeholder="Describe el motivo (mínimo 5 caracteres)"
            autoFocus
          />
        </label>
        {error ? <p className="inline-error">{error}</p> : null}
        <p className="page-footnote">{footnote}</p>
      </div>
    </Modal>
  );
}
